//import { BankAccountListing } from 'containers/CompanyModule/BankAccount/BankAccountListing'
import accessSecurityDigitalReportRoutes from 'containers/AccessSecurityModule/DigitalReport/AccessSecurityListingReport/AccessSecurityDigitalReportRoutes'
import apDigitalReportRoutes from 'containers/APModule/APDigitalReport/APDigitalReportRoutes'
import cbDigitalReportRoutes from 'containers/CashBookModule/CBDigitalReportModule/CBDigitalReportRoutes'
import glDigitalReportRoutes from 'containers/GeneralLedgerModule/GLDigitalReportModule/GLDigitalReportRoutes'

// const digitalReportRoutes = [
//   ...glDigitalReportRoutes,
//   ...cbDigitalReportRoutes,
//   ...apDigitalReportRoutes,
// ]

const digitalReportRoutes = [
  // {
  //   props: { exact: true, path: '/digital-reports' },
  //   component: <DigitalReportSubmenu />,
  // },
  ...accessSecurityDigitalReportRoutes,
  ...glDigitalReportRoutes,
  ...cbDigitalReportRoutes,
  ...apDigitalReportRoutes,
]

export default digitalReportRoutes
